/* The Sound (teaser page)
   - One song fades in as the page opens and fades out at the set length (60s), or when the visitor leaves.
     Browsers only allow sound after a first tap or key press, so when they say no it starts on that first touch.
   - The wave behind the ring breathes on its own and follows the music while it plays.
   - "Coming soon" takes the visitor to the sign-up. */
(function () {
  var sec = document.querySelector('[data-sound]');
  if (!sec || sec.dataset.ready) return;
  sec.dataset.ready = '1';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Coming soon → sign-up ---------- */
  [].forEach.call(sec.querySelectorAll('[data-soon]'), function (soon) { soon.addEventListener('click', function (e) {
    e.stopPropagation(); e.preventDefault();
    var j = d.getElementById('sound-join'); if (!j) return;
    j.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    var f = j.querySelector('input[type=email]'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, reduce ? 0 : 500);
  }); });

  /* ---------- the song ---------- */
  var playing = false, analyser = null, fbuf = null, rate = 44100, playT0 = 0, BPM = Math.max(60, Math.min(180, +sec.dataset.bpm || 92));
  var src = sec.dataset.src, box = sec.querySelector('[data-snd-player]');
  if (src && box) (function () {
    var LIMIT = Math.max(5, +sec.dataset.limit || 60), FIN = Math.max(0, +sec.dataset.fadeIn || 0), FOUT = Math.max(0, +sec.dataset.fadeOut || 0), BASE = .8;
    var probe = new Audio(); probe.volume = .5; var canVol = probe.volume === .5; // iPhone can't set volume: fades go through Web Audio
    var AC = window.AudioContext || window.webkitAudioContext, ctx = null, gain = null, audio, cors = !!AC;
    var kicked = false, started = false, userPaused = false, done = false, env = 1, fadeTo = null, raf = null, leaving = false;
    var btn = box.querySelector('[data-snd-toggle]'), prog = box.querySelector('[data-snd-prog]'), now = box.querySelector('[data-snd-now]'), hint = sec.querySelector('[data-snd-hint]');
    function fmt(x) { x = Math.max(0, Math.floor(x)); return Math.floor(x / 60) + ':' + ('0' + x % 60).slice(-2); }
    function len() { var dur = isFinite(audio.duration) && audio.duration ? audio.duration : LIMIT; return Math.min(LIMIT, dur); }
    function out(v) { v = Math.max(0, Math.min(1, v)); if (gain) gain.gain.value = v; else if (canVol) audio.volume = v; }
    function make(withCors) {
      var a = new Audio(); a.preload = 'auto'; if (withCors) a.crossOrigin = 'anonymous';
      a.addEventListener('error', function () {
        // the file host didn't allow Web Audio: play it plainly instead (the wave keeps its own rhythm)
        if (withCors && a === audio) {
          cors = false; gain = null; analyser = null; try { ctx && ctx.close(); } catch (x) {} ctx = null;
          var wasOn = playing; audio = make(false); if (wasOn) { out(BASE); audio.play().catch(function () { playing = false; paint(); waitForTouch(); }); }
        }
      });
      a.addEventListener('ended', function () { finish(); });
      a.src = src; a.load(); return a;
    }
    audio = make(cors);
    function graph() {
      if (!cors || gain || !AC) return;
      try {
        ctx = new AC(); var s = ctx.createMediaElementSource(audio);
        gain = ctx.createGain(); gain.gain.value = 0;
        analyser = ctx.createAnalyser(); analyser.fftSize = 1024; analyser.smoothingTimeConstant = .45;
        fbuf = new Uint8Array(analyser.frequencyBinCount); rate = ctx.sampleRate || 44100;
        s.connect(gain); gain.connect(analyser); analyser.connect(ctx.destination);
      } catch (e) { gain = null; analyser = null; cors = false; }
    }
    function paint() {
      sec.classList.toggle('is-playing', playing); box.classList.toggle('is-playing', playing);
      btn.querySelector('path').setAttribute('d', playing ? 'M4 2.5h3v11H4zM9 2.5h3v11H9z' : (done ? 'M8 3a5 5 0 1 1-4.6 3H1.8l2.7-3 2.7 3H4.9A3.5 3.5 0 1 0 8 4.5z' : 'M4 2.5v11l9-5.5z'));
      btn.setAttribute('aria-label', playing ? 'Pause' : (done ? 'Play again' : 'Play'));
    }
    function loop() {
      raf = null; if (!playing) return;
      var t = audio.currentTime, L = len();
      var a = FIN ? Math.min(1, t / FIN) : 1, b = FOUT ? Math.min(1, Math.max(0, (L - t) / FOUT)) : 1;
      if (fadeTo) { var k = Math.min(1, (performance.now() - fadeTo.t0) / fadeTo.ms); env = fadeTo.from + (fadeTo.to - fadeTo.from) * k; if (k >= 1) { var cb = fadeTo.cb; fadeTo = null; cb && cb(); if (!playing) return; } }
      var e = Math.min(a, b); out(BASE * env * e * e);
      if (now) now.textContent = fmt(t); if (prog) prog.style.width = (Math.min(1, t / L) * 100) + '%';
      if (!ended && t >= L - Math.max(FOUT, 2) - .5) end(); // the ending begins as the fade starts
      if (t >= L - .05) { finish(); return; }
      raf = requestAnimationFrame(loop);
    }
    function run() { if (!raf) raf = requestAnimationFrame(loop); }
    function ramp(to, ms, cb) { fadeTo = { from: env, to: to, t0: performance.now(), ms: ms, cb: cb }; run(); }
    function play(fromGesture) {
      if (playing) return;
      graph(); if (ctx && ctx.state === 'suspended') ctx.resume();
      if (done) { audio.currentTime = 0; done = false; }
      env = 1; fadeTo = null; out(0);
      var p = audio.play();
      // iPhone: a song routed through Web Audio can stay silent until it's paused and played once more.
      // Do that once, right as it starts (it's still fading in from silence, so nothing is heard).
      if (gain && !kicked) {
        kicked = true;
        var kick = function () {
          audio.removeEventListener('playing', kick);
          (ctx.state === 'running' ? Promise.resolve() : ctx.resume()).then(function () {
            if (!playing || audio.paused) return;
            audio.pause(); audio.play().catch(function () {});
          }).catch(function () {});
        };
        audio.addEventListener('playing', kick);
      }
      started = true; playing = true; playT0 = performance.now() - audio.currentTime * 1000; userPaused = false; if (hint) hint.hidden = true; sec.classList.remove('is-waiting'); paint(); run();
      if (p && p.catch) p.catch(function () { playing = false; started = false; paint(); waitForTouch(); }); // refused (no tap yet): wait for the first touch
      // played but the sound engine is still asleep (no tap yet): stay quiet and wait for the first touch
      if (!fromGesture && ctx && ctx.state !== 'running') setTimeout(function () { if (ctx.state !== 'running' && playing) { audio.pause(); playing = false; started = false; paint(); waitForTouch(); } }, 250);
    }
    function pause(ms) {
      if (!playing) return;
      ramp(0, ms == null ? 450 : ms, function () { audio.pause(); playing = false; paint(); });
      sec.classList.remove('is-playing'); box.classList.remove('is-playing');
    }
    function finish() { audio.pause(); playing = false; done = true; out(0); if (prog) prog.style.width = '100%'; paint(); end(); }

    // The ending starts as the song begins to fade: one last ripple, and the whole page above the sign-up
    // gives way to "Coming soon" while the music fades under it
    var again = sec.querySelector('[data-snd-again]'), down = sec.querySelector('.snd__down'), fin = sec.querySelector('[data-snd-finale]'), ended = false;
    function end() {
      if (ended) return; ended = true;
      sec.dispatchEvent(new CustomEvent('snd:end'));
      sec.classList.add('is-ended');
      if (fin) fin.setAttribute('aria-hidden', 'false');
      if (again) again.tabIndex = 0; if (down) down.tabIndex = 0;
    }
    function unend() {
      ended = false;
      sec.classList.remove('is-ended');
      if (fin) fin.setAttribute('aria-hidden', 'true');
      if (again) again.tabIndex = -1; if (down) down.tabIndex = -1;
    }
    if (again) again.addEventListener('click', function (e) {
      e.stopPropagation(); unend();
      if (playing) { audio.currentTime = 0; fadeTo = null; env = 1; } // still fading out: start over from the top
      else play(true);
    });

    btn.addEventListener('click', function (e) { e.stopPropagation(); if (playing) { userPaused = true; pause(); } else play(true); });

    // the first tap or key press anywhere starts it (except on the sign-up and the player itself)
    // only these count as a tap that unlocks sound on phones (a finger's pointerdown doesn't)
    var GEST = ['touchend', 'click', 'keydown'];
    function first(e) {
      if (e && e.target && e.target.closest && (e.target.closest('[data-snd-player]') || e.target.closest('form'))) return;
      GEST.forEach(function (g) { d.removeEventListener(g, first, true); });
      if (!started && !userPaused) play(true);
    }
    // Phones (and most browsers) never allow sound before the visitor's first tap, so the ring asks for one
    function waitForTouch() { if (hint) hint.hidden = false; sec.classList.add('is-waiting'); GEST.forEach(function (g) { d.addEventListener(g, first, true); }); }

    // try to start the moment the page opens (fades in from silence)
    if (canVol && !cors) play(false);
    else if (canVol) { graph(); if (ctx && ctx.state === 'running') play(false); else waitForTouch(); }
    else waitForTouch();

    // leaving: fade out first, then go
    d.addEventListener('click', function (e) {
      if (!playing || leaving || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]'); if (!a || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-open-drawer')) return;
      var url; try { url = new URL(a.href, location.href); } catch (x) { return; }
      if (url.pathname === location.pathname && url.hash) return;
      e.preventDefault(); leaving = true;
      var go = function () { location.href = url.href; };
      ramp(0, 1100, function () { audio.pause(); go(); }); setTimeout(go, 1400);
    });
    // switching tabs or closing: fade down (Web Audio keeps fading in the background) and stop
    d.addEventListener('visibilitychange', function () {
      if (d.visibilityState !== 'hidden' || !playing) return;
      if (gain && ctx) { gain.gain.setTargetAtTime(0, ctx.currentTime, .15); setTimeout(function () { audio.pause(); }, 700); }
      else audio.pause();
      playing = false; paint();
    });
    window.addEventListener('pagehide', function () { audio.pause(); playing = false; });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { leaving = false; playing = false; out(0); paint(); } });
    paint();
  })();


  /* ---------- the soundtrack visual ----------
     A score-like field of fine vertical lines mirrored out from the ring: low notes next to the ring,
     highs toward the edges. It reads the music itself, so every hit moves it; each kick drum sends a
     gold ripple out of the ring and lifts the whole field. If the song's host blocks reading the music,
     it keeps time with the tempo (BPM) set in the theme editor instead. */
  var cv = sec.querySelector('[data-wave]');
  if (!cv || !cv.getContext) return;
  var g = cv.getContext('2d'), W = 0, H = 0, dpr = 1, ring = sec.querySelector('.snd__ring'), stage = sec.querySelector('.snd__stage');
  var box2 = sec.querySelector('[data-snd-player]'), art = [].slice.call(sec.querySelectorAll('.snd__bars i'));
  var N = 0, cur = [], ripples = [], hist = [], lastBeat = 0, beatN = -1, beat = 0, lv = 0;
  function size() {
    dpr = Math.min(2, window.devicePixelRatio || 1); W = cv.clientWidth; H = cv.clientHeight;
    cv.width = W * dpr; cv.height = H * dpr; g.setTransform(dpr, 0, 0, dpr, 0, 0);
    N = Math.max(18, Math.floor(W / 2 / 6)); cur = []; for (var i = 0; i < N; i++) cur.push(0);
  }
  size(); window.addEventListener('resize', size);
  sec.addEventListener('snd:end', function () { onBeat(performance.now(), 1); });
  function noise(i) { var x = Math.sin(i * 127.1 + 3.7) * 43758.5453; return x - Math.floor(x); }
  function binOf(hz) { return Math.min(fbuf.length - 1, Math.max(1, Math.round(hz / (rate / 2) * fbuf.length))); }
  function onBeat(now, s) { lastBeat = now; beat = Math.min(1, s); ripples.push({ t0: now, s: beat }); if (ripples.length > 5) ripples.shift(); }
  function frame() {
    var now = performance.now(), t = now / 1000, live = playing && analyser, tgt = [], i, d;
    if (sec.classList.contains('is-ended') && !playing && !ripples.length) { if (!reduce) requestAnimationFrame(frame); return; }
    if (live) {
      analyser.getByteFrequencyData(fbuf);
      // the kick: energy from 40 to 150 Hz, against the last second of music
      var lo = binOf(40), hi = Math.max(lo + 1, binOf(150)), e = 0;
      for (i = lo; i <= hi; i++) e += fbuf[i];
      e /= (hi - lo + 1) * 255; hist.push(e); if (hist.length > 60) hist.shift();
      var avg = 0; for (i = 0; i < hist.length; i++) avg += hist[i]; avg /= hist.length;
      if (e > .22 && e > avg * 1.18 && now - lastBeat > 260) onBeat(now, .5 + (e - avg) * 5);
      for (i = 0; i < N; i++) { d = i / (N - 1); var v = fbuf[binOf(45 * Math.pow(260, d))] / 255; tgt.push(Math.min(1, Math.pow(v, 2.2) * .85 * (1 + d * 1.2))); }
    } else if (playing) {
      // keeping time with the tempo: a kick on every beat, a softer lift on the off-beat
      var spb = 60 / BPM, x = (now - playT0) / 1000 / spb, n = Math.floor(x), ph = x - n;
      if (n !== beatN) { beatN = n; onBeat(now, n % 4 === 0 ? .9 : .6); }
      var kick = Math.pow(1 - ph, 5), off = Math.pow(Math.max(0, 1 - Math.abs(ph - .5) * 4), 2) * .45;
      for (i = 0; i < N; i++) { d = i / (N - 1); var sh = .5 + .5 * Math.sin(t * (1.3 + noise(i) * 2.2) + i * .9); tgt.push(Math.min(1, kick * .85 * Math.pow(1 - d, 1.4) + off * Math.pow(d, .6) * .6 + sh * .22 * (.4 + .6 * noise(i + 9)))); }
    } else {
      // resting: a quiet, slow breath
      for (i = 0; i < N; i++) { d = i / (N - 1); tgt.push(.035 + .03 * (1 - d) * (1 + Math.sin(t * .9 - i * .28))); }
    }
    var sum = 0;
    for (i = 0; i < N; i++) { var k = tgt[i] > cur[i] ? .6 : .11; cur[i] += (tgt[i] - cur[i]) * k; sum += cur[i]; }
    lv += (sum / N - lv) * .2; beat *= .9;

    g.clearRect(0, 0, W, H);
    var cx = W / 2, mid = H / 2, rr = ring ? ring.offsetWidth / 2 : 59, band = stage ? stage.clientHeight * .48 : 90;
    var start = rr + 14, sp = (cx - start) / N, lw = Math.max(1, Math.min(1.8, sp * .3));
    // the score line
    g.fillStyle = 'rgba(184,151,90,' + (.1 + beat * .12).toFixed(3) + ')'; g.fillRect(0, mid - .5, W, 1);
    // the field
    g.lineCap = 'round'; g.lineWidth = lw;
    for (i = 0; i < N; i++) {
      d = i / (N - 1); var fade = 1 - Math.pow(d, 2.6), v = cur[i];
      var h = (1.5 + v * band * (1 + beat * .3)) * fade; if (h < .8) continue;
      g.strokeStyle = 'rgba(' + (v > .82 ? '242,238,230' : '184,151,90') + ',' + ((.14 + v * .7 + beat * .12) * (.35 + .65 * fade)).toFixed(3) + ')';
      var off = start + i * sp + sp / 2;
      g.beginPath(); g.moveTo(cx - off, mid - h); g.lineTo(cx - off, mid + h); g.moveTo(cx + off, mid - h); g.lineTo(cx + off, mid + h); g.stroke();
    }
    // the ripples: one per kick, out from the ring
    for (i = ripples.length - 1; i >= 0; i--) {
      var r = ripples[i], a = (now - r.t0) / 1500; if (a >= 1) { ripples.splice(i, 1); continue; }
      var ease = 1 - Math.pow(1 - a, 3);
      g.beginPath(); g.arc(cx, mid, rr + 4 + ease * Math.min(H * .48, 150), 0, Math.PI * 2);
      g.strokeStyle = 'rgba(184,151,90,' + (Math.pow(1 - a, 2) * .55 * r.s).toFixed(3) + ')'; g.lineWidth = 1.2; g.stroke();
    }
    if (ring) { ring.style.setProperty('--beat', beat.toFixed(3)); ring.style.setProperty('--lv', Math.min(1, lv * 2.2).toFixed(3)); }
    if (box2 && art.length) {
      box2.classList.toggle('is-live', playing);
      if (playing) art.forEach(function (b, j) { var c = cur[Math.min(N - 1, Math.floor(N * [.02, .15, .35, .6][j]))] || 0; b.style.height = Math.round(18 + Math.min(1, c * 1.3 + beat * .25) * 70) + '%'; });
    }
    if (!reduce) requestAnimationFrame(frame);
  }
  frame();
})();
